import { render, staticRenderFns } from "./no-data-page.vue?vue&type=template&id=21f9ef37&"
import script from "./no-data-page.vue?vue&type=script&lang=js&"
export * from "./no-data-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "no-data-page.vue"
export default component.exports